/* eslint-disable camelcase */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { GetRegion } from 'constants.js';

import { emailRegex } from 'helpers/validators';
import { Form } from 'cvlib';

import getCountryList, { FLAG_BY_FLOW } from '../helpers/countryList';
import { useSelector } from 'react-redux';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import '../Register.scss';
const EmailForm = props => {
  const {
    Onboarding_RegistrateRCU_Form_TextoTitulo,
    Onboarding_RegistrateRCU_Form_TextoSubTitulo_Mail,
    Onboarding_RegistrateRCU_TextoPlaceholder1_Mail,
    Onboarding_RegistrateRCU_Texto2,
    Onboarding_RegistrateRCU_Texto4,
    Onboarding_RegistrateRCU_Texto3,
    Onboarding_RegistrateRCU_TextoBotonPrimario,
    Onboarding_RegistrateRCU_TextoBotonSecundario,
    Onboarding_RegistrateRCU_TextoPromociones1,
    Onboarding_RegistrateRCU_TextoPromociones2,
    Onboarding_RegistrateRCU_Texto5,
    Onboarding_RegistrateRCU_Texto6,
    email_tooltip_valid_label_validation,
    registerMail_tooltip_error_label,
    register_access_title_label,
    register_access_description_label,
    register_access_option_button_next,
    register_access_option_button_cancel,
    register_access_termsConditions_label_link,
    register_access_promotions_label_link,
    Onboarding_RegistrateRCU_TextoToggle1,
    Onboarding_RegistrateRCU_TextoBotonSecundario1,
    Onboarding_RegistroRCU_Texto7,
    register_access_login_label_link,
    register_access_placeHolder_textfield,
    password_tooltip_checkTermsConditions_label_validation,
    password_tooltip_completeField_label_validation,
    telmex_chat_text,
  } = props.translations;
  const {
    onNextClicked,
    onCancelClicked,
    onChatClicked,
    onLoginClicked,
    onChangeCountry,
    onShowTerms,
    onAcceptTerms,
    onPromotionsClicked,
    emailValid,
    clearValidEmailError,
    errorServiceGetUserInfo
  } = props;
  const [emptyEmail, setEmptyEmail] = useState(true);
  const [emailValue, setEmailValue] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const countryList = getCountryList(FLAG_BY_FLOW.REGISTER);
  const claroAdEnable = useSelector(selectMetadataKeyByRegion("cv_advertising_config"));
  const showTermsTooltip =
    emailValid && !emptyEmail && emailRegex.exec(emailValue);

  const errorRegistes  = ()=> {
    if(!emailValid && !errorServiceGetUserInfo){
      return registerMail_tooltip_error_label;
    }

    if(errorServiceGetUserInfo){
      return email_tooltip_valid_label_validation;
    }

    return false;
  }

  const elements = [
    {
      element: 'title',
      content: claroAdEnable?.enable ? Onboarding_RegistrateRCU_Form_TextoTitulo : register_access_title_label,
    },
    {
      element: 'group',
      direction: 'vertical',
      children: [
        {
          element: 'subtitle',
          content: claroAdEnable?.enable ? Onboarding_RegistrateRCU_Form_TextoSubTitulo_Mail : register_access_description_label,
          className: claroAdEnable?.enable ?  'subtitle-register' : 'subtitle-class',
        },
        countryList && {
          element: 'item',
          type: 'country',
          name: 'countrySelect',
          id: 'countrySelect',
          defaultValue: GetRegion(),
          countries: countryList,
          onChange: ({ value }) => onChangeCountry(value),
          style: { width: '11.5rem', margin: 'auto' },
        },
        {
          element: 'item',
          type: 'email',
          placeholder: claroAdEnable?.enable ? Onboarding_RegistrateRCU_TextoPlaceholder1_Mail : register_access_placeHolder_textfield,
          message: email_tooltip_valid_label_validation,
          error: errorRegistes(),
          name: 'emailRegister',
          id: 'emailRegister',
          autoFocus: true,
          registerOptions: {
            required: password_tooltip_completeField_label_validation,
            pattern: {
              value: emailRegex,
              message: email_tooltip_valid_label_validation,
            },
          },
          onChange: ({ target }) => {
            setEmptyEmail(target.value.length <= 0);
            setEmailValue(target.value);
          },
          clearOtherErrors: clearValidEmailError,
        },
      ],
    },
    {
      element: 'item',
      type: 'check',
      children: register_access_termsConditions_label_link,
      expand: 2,
      position: 'bottom',
      name: 'termsConditions',
      id: 'termsConditions',
      message: password_tooltip_checkTermsConditions_label_validation,
      onChange: ({ target }) => {
        if (target.checked) onAcceptTerms();
        setTermsAccepted(target.checked);
      },
      anchorProps: {
        onClick: onShowTerms,
      },
      registerOptions: showTermsTooltip && {
        required: password_tooltip_checkTermsConditions_label_validation,
      },
      clearErrorsOnClick: true,
    },
    {
      element: 'button',
      type: 'red',
      content: claroAdEnable?.enable ? Onboarding_RegistrateRCU_TextoBotonPrimario : register_access_option_button_next,
      submit: onNextClicked,
      dimmed: emptyEmail || !termsAccepted,
    },
    {
      element: 'button',
      type: 'gray',
      content: claroAdEnable?.enable ? Onboarding_RegistrateRCU_TextoBotonSecundario : register_access_option_button_cancel,
      onClick: onCancelClicked,
    },
    {
      element: 'message',
      content: register_access_promotions_label_link,
      position: 'bottom',
      expand: 1,
      onClick: onPromotionsClicked,
      clearErrorsOnClick: true,
    },
    claroAdEnable?.enable ?
    [{
      element: 'message',
      content: Onboarding_RegistrateRCU_TextoToggle1,
      position: 'bottom',
      expand: 0.8,
    }, {
      element: 'button',
      type: 'gray',
      content: Onboarding_RegistrateRCU_TextoBotonSecundario1,
      onClick: onLoginClicked,
    }] :
    {
      element: 'message',
      content: register_access_login_label_link,
      position: 'bottom',
      expand: 0.8,
      onClick: onLoginClicked,
    },
    GetRegion() === 'mexico' && {
      element: 'message',
      content: telmex_chat_text,
      position: 'bottom',
      expand: 0.5,
      onClick: onChatClicked,
    },
  ];

  return <Form elements={elements} />;
};

EmailForm.propTypes = {
  onShowTerms: PropTypes.func.isRequired,
  onAcceptTerms: PropTypes.func.isRequired,
  onChangeCountry: PropTypes.func.isRequired,
  onPromotionsClicked: PropTypes.func.isRequired,
  onCancelClicked: PropTypes.func.isRequired,
  onLoginClicked: PropTypes.func.isRequired,
  onNextClicked: PropTypes.func.isRequired,
  onChatClicked: PropTypes.func.isRequired,
  emailValid: PropTypes.bool,
  clearValidEmailError: PropTypes.func,
  translations: PropTypes.shape({
    registerMail_tooltip_error_label: PropTypes.string,
    email_tooltip_valid_label_validation: PropTypes.string,
    telmex_chat_text: PropTypes.string,
    register_access_title_label: PropTypes.string,
    register_access_description_label: PropTypes.string,
    register_access_option_button_next: PropTypes.string,
    register_access_option_button_cancel: PropTypes.string,
    register_access_termsConditions_label_link: PropTypes.string,
    register_access_promotions_label_link: PropTypes.string,
    register_access_login_label_lin: PropTypes.string,
    register_access_placeHolder_textfield: PropTypes.string,
    password_tooltip_checkTermsConditions_label_validation: PropTypes.string,
    password_tooltip_completeField_label_validation: PropTypes.string,
  }),
};

EmailForm.defaultProps = {
  emailValid: true,
};

export default EmailForm;
